module.exports = __webpack_public_path__ + "static/img/plist_wx_flow.fe9f14f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plist_wx_flow.jpg
// module id = 283
// module chunks = 0 1 2 3 4